"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Error = _interopRequireDefault(require("./svg/Error404"));

var _NothingFound = _interopRequireDefault(require("./svg/NothingFound"));

var _DetailPlan = _interopRequireDefault(require("./svg/DetailPlan"));

var _DetailPlanInvalidate = _interopRequireDefault(require("./svg/DetailPlanInvalidate"));

var _Sademevesi = _interopRequireDefault(require("./svg/Sademevesi"));

var _Valgustus = _interopRequireDefault(require("./svg/Valgustus"));

var _Menetluses = _interopRequireDefault(require("./svg/Menetluses"));

var _Teed = _interopRequireDefault(require("./svg/Teed"));

var _TeedAlternative = _interopRequireDefault(require("./svg/TeedAlternative"));

var _InWork = _interopRequireDefault(require("./svg/InWork"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @visibleName Illustrations
 */
function Illustration(_ref) {
  var type = _ref.type,
      margin = _ref.margin,
      size = _ref.size;
  var styles = {
    margin: margin || undefined,
    width: size,
    height: size
  };

  switch (type) {
    case 'nothingFound':
      return /*#__PURE__*/_react.default.createElement(_NothingFound.default, {
        styles: styles
      });

    case 'detailPlan':
      return /*#__PURE__*/_react.default.createElement(_DetailPlan.default, {
        styles: styles
      });

    case 'detailPlanInvalidate':
      return /*#__PURE__*/_react.default.createElement(_DetailPlanInvalidate.default, {
        styles: styles
      });

    case 'sademevesi':
      return /*#__PURE__*/_react.default.createElement(_Sademevesi.default, {
        styles: styles
      });

    case 'valgustus':
      return /*#__PURE__*/_react.default.createElement(_Valgustus.default, {
        styles: styles
      });

    case 'menetluses':
      return /*#__PURE__*/_react.default.createElement(_Menetluses.default, {
        styles: styles
      });

    case 'teed':
      return /*#__PURE__*/_react.default.createElement(_Teed.default, {
        styles: styles
      });

    case 'teedAlternative':
      return /*#__PURE__*/_react.default.createElement(_TeedAlternative.default, {
        styles: styles
      });

    case 'inWork':
      return /*#__PURE__*/_react.default.createElement(_InWork.default, {
        styles: styles
      });

    case 'error404':
    default:
      return /*#__PURE__*/_react.default.createElement(_Error.default, {
        styles: styles
      });
  }
}

Illustration.propTypes = {
  /** Type of illustration */
  type: _propTypes.default.oneOf(['error404', 'nothingFound', 'detailPlan', 'detailPlanInvalidate', 'sademevesi', 'valgustus', 'menetluses', 'teed', 'teedAlternative', 'inWork']).isRequired,

  /** Margins */
  margin: _propTypes.default.string,

  /** Height and width of icon */
  size: _propTypes.default.string
};
Illustration.defaultProps = {
  margin: '0',
  size: '62px'
};
var _default = Illustration;
exports.default = _default;